import React from "react";
import { EditOutlined, CheckOutlined, DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import { Tooltip, Button } from './styles';

export default ({ id, name, text, style, type, iconType, hiden, onClick }) => {

    function returnIcon(iconType) {
        switch (iconType) {
            case "edit":
                return <EditOutlined />
            case "check":
                return <CheckOutlined />
            case "delete":
                return <DeleteOutlined />
            case "close":
                return <CloseOutlined />
        }
    }

    return (
        <Tooltip title={text}>
            <Button
                id={id}
                name={name}
                type={type}
                style={style}
                shape="circle"
                onClick={onClick}                
                iconType={iconType}
                hiden={hiden}
                icon={returnIcon(iconType)}
            />
        </Tooltip>
    )
}